<template>
  <v-layout>
    <v-dialog v-model="dialogCompleted" persistent max-width="70%">
      <v-card>
        <v-card-title class="headline" v-t="{path: 'questionnaire.completedDialog.TITLE'}"></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p class="normal-p-font-size" v-html="$t('questionnaire.completedDialog.BODY')"></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="dialogCompleted = false">{{ $t('questionnaire.completedDialog.CLOSE') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 md10 offset-md1>
      <v-container fluid grid-list-sm>
        <v-layout wrap>
          <v-flex v-for="(item,n) in recommendations" :key="n" xs12 md6>
            <div style="height: 100%; padding: 2px; display: flex; flex-direction: column">
              <v-card style="height: 100%; flex-grow: 1" hover @click.native="toggleSelectRecommendation(item)" v-bind:class="{'light-green': isSelected(item)}">
                  <v-card-title>
                <span style="margin-left: auto; margin-right: 0;">
                  <v-btn small flat v-on:click.native.stop="showScope(item.scope)">
                      <span>
                        {{ $t('info.scopes.SCOPE'+item.scope+'.TITLE', questionnaire.version) }}
                      </span>
                    <v-icon right light small>info_outline</v-icon>
                  </v-btn>
                </span>
                  </v-card-title>
                  <v-card-title class="title" v-t="{path: 'ITEM'+item.id+'.TITLE', locale: questionnaire.version}">
                  </v-card-title>
                  <v-card-title>
                <span style="float: left;">
                  <v-icon color="deep-purple lighten-4" v-if="item.complexity == 1">radio_button_checked</v-icon>
                  <v-icon color="deep-purple lighten-4" v-else>radio_button_unchecked</v-icon>
                  <v-icon color="deep-purple lighten-1" v-if="item.complexity == 2">radio_button_checked</v-icon>
                  <v-icon color="deep-purple lighten-1" v-else>radio_button_unchecked</v-icon>
                  <v-icon color="deep-purple darken-4" v-if="item.complexity == 3">radio_button_checked</v-icon>
                  <v-icon color="deep-purple darken-4" v-else>radio_button_unchecked</v-icon>
                </span>
                    <v-btn flat icon class="subheading" style="margin-left: auto; margin-right: 0;" v-on:click.stop="showExplanation(item.id)">
                      <v-icon>info_outline</v-icon>
                    </v-btn>
                  </v-card-title>
                </v-card>
              <v-btn class="mt-0" color="primary" block v-on:click="showIncorporate(item.id)">
                <span class="caption" v-t="{path: 'info.incorporateDialog.BUTTON_SHORT', locale: questionnaire.version}"></span>
                <v-icon light small right>live_help</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-btn large bottom right fixed class="success" v-show="!this.saved" :disabled="this.selected < 3" @click.native="showComments = true">
      {{ $t('forms.FINISH') }}
    </v-btn>
    <v-btn fab large bottom right fixed class="success" v-show="this.saved" @click.native="forward"><v-icon>forward</v-icon></v-btn>
    <evaloe-assist :version="this.questionnaire.version"
                   :incorporateHelp="this.incorporateHelp"
                   :incorporateKey="this.incorporateKey"
                   v-on:close="closeAssist"
    ></evaloe-assist>

    <v-dialog v-model="showComments" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline" v-t="{path: 'questionnaire.commentsDialog.TITLE'}"></v-card-title>
        <v-divider></v-divider>
        <v-textarea style="margin: 2em 2em 0"
          :label="$t('questionnaire.commentsDialog.LABEL')"
          v-model="comments"
          rows="3"
          textarea
          multi-line
          auto-grow></v-textarea>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="blue--text darken-1" flat @click.native="showComments = false">{{ $t('questionnaire.completedDialog.CLOSE') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="saveRecommendationsAndComments">{{ $t('forms.FINISH') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExplanation" lazy scrollable max-width="70%">
      <v-card>
        <v-card-title class="headline" v-t="{path: 'ITEM'+this.dialogExplanationKey+'.TITLE', locale: questionnaire.version}"></v-card-title>
        <v-divider></v-divider>

        <v-card-text v-html="$t('ITEM'+this.dialogExplanationKey+'.ITEM_EXPLANATION', questionnaire.version)"></v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="white-space: unset;" class="blue--text darken-1" flat @click.native="dialogExplanation = false">
            <span v-html="$t('questionnaire.itemHelpDialog.CLOSE_BUTTON')"></span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="scopeHelp" lazy scrollable max-width="50%">
      <v-card>
        <v-card-title class="headline" v-t="{path: 'info.scopes.SCOPE'+this.scopeKey+'.TITLE', locale: questionnaire.version}"></v-card-title>
        <v-divider></v-divider>

        <v-card-text v-html="$t('info.scopes.SCOPE'+this.scopeKey+'.EXPLANATION', questionnaire.version)">

        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="scopeHelp = false">
            <span v-html="$t('questionnaire.itemHelpDialog.CLOSE_BUTTON')"></span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>
<style>
  button .btn__content {
    white-space: inherit;
    flex: inherit;
  }
</style>
<script>
  import {QuestionnaireResource} from '../../api/questionnaire'
  import EvaloeAssist from './EvaloeAssist'
  export default {
    name: 'recommendations',
    components: {
      'evaloe-assist': EvaloeAssist
    },
    data () {
      return {
        recommendations: [],
        questionnaire: {},
        selected: 0,
        recommendationSelected: [],
        scopeKey: 30,
        scopeHelp: false,
        dialogExplanationKey: 30,
        dialogExplanation: false,
        dialogCompleted: true,
        recommended: [],
        saved: false,
        incorporateKey: false,
        incorporateHelp: false,
        showComments: false,
        comments: '',
        recommendationsSaved: false
      }
    },
    beforeRouteEnter: function (to, from, next) {
      next()
    },
    created: function () {
      QuestionnaireResource().getRecommendations({id: this.$route.params.questionnaireId}).then(response => {
        this.recommendations = response.body
      }, response => {
        console.log(response)
      })
      QuestionnaireResource().get({id: this.$route.params.questionnaireId}).then(response => {
        this.questionnaire = response.body
      }, response => {
        console.log('error' + response.body)
      })
      QuestionnaireResource().getRecommended({id: this.$route.params.questionnaireId}).then(response => {
        this.recommended = response.body
        for (const recommendation of this.recommended) {
          if (recommendation.chosen === true) {
            this.saved = true
            this.recommendationSelected.push(recommendation.itemId)
          }
        }
      }, response => {
        console.log(response)
      })
    },
    mounted: function () {

    },
    watch: {},
    computed: {
    },
    methods: {
      showScope: function (scopeId) {
        this.scopeKey = scopeId
        this.scopeHelp = true
      },
      showExplanation: function (itemId) {
        this.dialogExplanationKey = itemId
        this.dialogExplanation = true
      },
      toggleSelectRecommendation: function (item) {
        if (!this.saved) {
          if (this.isSelected(item)) {
            --this.selected
            const index = this.recommendationSelected.indexOf(item.id)
            if (index > -1) {
              this.recommendationSelected.splice(index, 1)
            }
          } else {
            if (this.selected < 3) {
              ++this.selected
              this.recommendationSelected.push(item.id)
            }
          }
        }
      },
      isSelected: function (item) {
        for (const recommendation of this.recommendationSelected) {
          if (recommendation === item.id) return true
        }
        return false
      },
      saveRecommendationsAndComments: async function () {
        try {
          if (!this.recommendationsSaved) {
            await QuestionnaireResource().saveRecommendations({id: this.$route.params.questionnaireId}, this.recommendationSelected)
            this.recommendationsSaved = true
          }
          if (this.comments) {
            await QuestionnaireResource().saveComments({id: this.$route.params.questionnaireId}, this.comments)
          }
          await this.$router.push({ name: 'Home' })
        } catch (e) {
          console.log(e)
        }
      },
      forward: function () {
        this.$router.push({ name: 'Questionnaires' })
      },
      showIncorporate: function (itemId) {
        this.incorporateKey = itemId
        this.incorporateHelp = true
      },
      closeAssist: function () {
        this.incorporateHelp = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/Recommendations.vue